import { Routes } from '@angular/router';
import { oauthComponent } from '@anonymous/oauth/oauth.component';

export const routes: Routes = [
  // Core routes
  { path: '', loadChildren: () => import('@core/core.module').then(m => m.CoreModule)},
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  // Anonymous routes
  { path: '', loadChildren: () => import('@anonymous/anonymous.module').then(m => m.AnonymousModule) },
  { path: 'api/auth/oauth/microsoft/callback', component: oauthComponent },


];
